import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Results({ stories }) {
    return (
        <Default>
            <Head>
                <title>Verhalen</title>
                <link rel="canonical" href={route("stories")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hier vindt je een overzicht van verhalen van mensen die aan ons twaalf weken programma hebben deelgenomen."
                />
                <meta
                    property="og:description"
                    content="Hier vindt je een overzicht van verhalen van mensen die aan ons twaalf weken programma hebben deelgenomen."
                />
                <meta property="og:url" content={route("stories")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Verhalen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl">
                        Verhalen
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="physical-transformations"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Fysieke transformaties
                        </Link>
                        <Link
                            to="success-stories"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase md:ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Succesverhalen
                        </Link>
                    </div>
                </Hero> */}

                <div className="bg-black">
                    <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                        <div className="relative">
                            <div className="relative md:p-6">
                                {stories.map((story, key) => (
                                    <div
                                        className="lg:grid lg:grid-cols-3 lg:gap-6 mb-4"
                                        key={key}
                                    >
                                        <div className="mt-6 prose prose-indigo prose-lg text-gray-500 lg:mt-0 col-span-2">
                                            <div className=" leading-6 font-medium space-y-1">
                                                <h2 className="text-5xl font-custom italic uppercase text-gray-100 ">
                                                    {story.name}
                                                    <span className="text-we-are-yellow ml-4 font-custom text-3xl font-bold uppercase align-middle">
                                                        {`-${story.result}kg`}
                                                    </span>
                                                </h2>
                                                <p className="text-gray-300 font-semibold text-lg">
                                                    WE ARE – Personal Training{" "}
                                                    {story.location}
                                                </p>
                                            </div>
                                            <div className="text-lg">
                                                <p className="text-gray-100">
                                                    {story.story}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="prose prose-indigo prose-lg text-gray-500 lg:max-w-none xs:mt-4 sm:mt-4">
                                            <picture>
                                                <source
                                                    srcSet={story.webpImageUrl}
                                                    type="image/webp"
                                                    alt={story.name}
                                                    className="object-cover shadow-lg rounded-lg"
                                                />
                                                <source
                                                    srcSet={story.imageUrl}
                                                    type="image/jpeg"
                                                    alt={story.name}
                                                    className="object-cover shadow-lg rounded-lg"
                                                />
                                                <img
                                                    src={story.imageUrl}
                                                    alt={story.name}
                                                    className="object-cover shadow-lg rounded-lg"
                                                />
                                            </picture>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
